export enum EXPERTISE {
  AUDIOVISUAL = 'audiovisual',
  BANK_INSURANCE = 'bank',
  COURRIER = 'courrier',
  DIGITAL = 'digital',
  ENERGY = 'energy',
  HUMAN_RESOURCES = 'human-resource',
  INTERNATIONAL = 'international',
  MOBILE = 'mobile',
  PARTNERS = 'partner',
  TRANSVERSE = 'transverse',
  URBAN = 'urban',
}
